"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _colors = require("./colors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var isSelectionTruthy = function isSelectionTruthy(value) {
  return !(Array.isArray(value) && !value.length || value === null || value === undefined || value === '');
};

var isStateless = function isStateless(component) {
  return !component.prototype.render;
};

var SelectWrapper =
/*#__PURE__*/
function (_Component) {
  _inherits(SelectWrapper, _Component);

  function SelectWrapper() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SelectWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SelectWrapper)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "selectReference", null);

    _defineProperty(_assertThisInitialized(_this), "state", {
      shouldFloat: isSelectionTruthy(_this.props.value)
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function () {
      _this.setState({
        shouldFloat: true
      }, _this.props.onFocus);
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (event) {
      var _this$props = _this.props,
          value = _this$props.value,
          onBlurResetsInput = _this$props.onBlurResetsInput;

      if (onBlurResetsInput === false && event.target.value || isSelectionTruthy(value)) {
        _this.setState({
          shouldFloat: true
        }, _this.props.onBlur);
      } else {
        _this.setState({
          shouldFloat: false
        }, _this.props.onBlur);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputKeyDown", function () {
      _this.setState({
        shouldFloat: true
      });
    });

    return _this;
  }

  _createClass(SelectWrapper, [{
    key: "focus",
    value: function focus() {
      if (this.selectReference) {
        this.selectReference.input.focus();
      }
    }
    /* eslint-disable-next-line camelcase */

  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.setState({
        shouldFloat: isSelectionTruthy(nextProps.value)
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var shouldFloat = this.state.shouldFloat;
      var _this$props2 = this.props,
          containerClassName = _this$props2.containerClassName,
          placeholder = _this$props2.placeholder,
          label = _this$props2.label,
          selectedSelect = _this$props2.selectedSelect,
          required = _this$props2.required,
          helpText = _this$props2.helpText;
      var ref = isStateless(selectedSelect) ? undefined : function (select) {
        _this2.selectReference = select;
      };
      var className = "react-select-wrapper form-group ".concat(shouldFloat ? 'form-group-active' : '', " ").concat(containerClassName || '');
      return _react["default"].createElement("div", {
        className: className
      }, _react["default"].createElement("label", {
        style: {
          pointerEvents: 'none',
          wordWrap: 'break-word',
          width: '80%'
        },
        className: "control-label"
      }, placeholder || label, required ? _react["default"].createElement("span", {
        style: {
          color: _colors.persimmon.base
        }
      }, " *") : ''), _react["default"].createElement(selectedSelect, _objectSpread({}, this.props, {
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onInputKeyDown: this.handleInputKeyDown,
        placeholder: '',
        ref: ref
      })), helpText ? _react["default"].createElement("small", {
        className: "help-block"
      }, helpText) : null);
    }
  }]);

  return SelectWrapper;
}(_react.Component);

exports["default"] = SelectWrapper;
SelectWrapper.propTypes = {
  containerClassName: _propTypes["default"].string,
  required: _propTypes["default"].bool,
  selectedSelect: _propTypes["default"].func,
  label: _propTypes["default"].node,
  placeholder: _propTypes["default"].node,
  value: _propTypes["default"].any,
  // eslint-disable-line react/forbid-prop-types
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  helpText: _propTypes["default"].node,
  onBlurResetsInput: _propTypes["default"].bool
};